import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { iconClass } from 'src/app/enums/icon-class.enum';
import { MenuIcon } from 'src/app/shared/models/menu/menu-icon';
import { IconType } from 'src/app/tinea-components/icon/enum/icon-type';
import { BtnActionEnum } from '../enums/btn-action.enum';
import { BtnActionInterface } from '../interfaces/btnAction.interface';

@Injectable({
  providedIn: 'root'
})


export class BtnActionService {

  btnInterface : BtnActionInterface;
  
  constructor(
    private translate: TranslateService,
  ) { }

  ngOnInit() {
  }
  
  getIconTextBtn(typeBtn : BtnActionEnum) : BtnActionInterface {
    let btnInterface : BtnActionInterface;
    switch (typeBtn) {
      case BtnActionEnum.EXPORT : 
        btnInterface = {
          text : this.translate.instant('action.export'),
          typeBtn : BtnActionEnum.EXPORT,
          icon : iconClass.EXPORT
        }
        break;
      case BtnActionEnum.GROUP : 
        btnInterface = {
          text : this.translate.instant('action.filter.group'),
          typeBtn : BtnActionEnum.GROUP,
          icon : iconClass.GROUP,
        }
        break;
      case BtnActionEnum.SEARCH : 
        btnInterface = {
          text : this.translate.instant('action.filter.search'),
          typeBtn : BtnActionEnum.SEARCH,
          icon : iconClass.SEARCH,
        }
        break;
      case BtnActionEnum.RAFRAICHIR : 
        btnInterface = {
          text : this.translate.instant('action.filter.refresh'),
          typeBtn : BtnActionEnum.RAFRAICHIR,
          icon : iconClass.REFRESH,
        }
        break;
      case BtnActionEnum.TRIE : 
        btnInterface = {
          text : this.translate.instant('action.filter.sort'),
          typeBtn : BtnActionEnum.TRIE,
          icon : iconClass.SORT,
        }
        break;
    }
    return btnInterface;
  }

  getIconTextBtnCustom(text : string, icon: string) : BtnActionInterface {
    let btnInterface : BtnActionInterface;

    btnInterface = {
        text : this.translate.instant(text),
        typeBtn : BtnActionEnum.CUSTOM,
        icon : <iconClass>icon
      }

      return btnInterface;
    }

    
  }

